module.exports = __webpack_public_path__ + "static/assets/5c89b7688ca800a918d921633d17bc8d.jpg";